<template lang="pug">
.static-elements
    .static-wrapper-inner.navigation-container
        Navigation.staticnav
    .static-wrapper-inner.static-footer
        p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
export default {
    name: "static-elements",
    components: {
        Navigation,
    },
};
</script>

<style lang="scss">
.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}
</style>